import { snapshot } from 'valtio'
import { buildAxiosInstance, DEFAULT_LIMIT } from '../../../../shared/utils/apiUtils'
import { dataExportsProxy } from './dataExportsProxy'

const buildFetchParams = (): { [key in string]: string | number } => {
  const { filters } = snapshot(dataExportsProxy)
  const params: { [key in string]: string | number } = {
    limit: DEFAULT_LIMIT,
    offset: filters.offset
  }

  if (filters.sortColumn && filters.sortDirection) {
    params.sortColumn = filters.sortColumn
    params.sortDirection = filters.sortDirection
  }

  return params
}

interface Args {
  displayLoader: boolean
  appendRecords?: boolean
}

export async function executeUserDataExportsSearch ({ displayLoader = true, appendRecords = false }: Args): Promise<void> {
  if (displayLoader) { dataExportsProxy.apiCall.loading = true }
  dataExportsProxy.apiCall.error = null
  try {
    const params = buildFetchParams()
    const response = await buildAxiosInstance().post('/api/data_exports/search', params)
    if (response.data.error) {
      dataExportsProxy.apiCall.error = response.data.error
      return
    }
    if (appendRecords) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      dataExportsProxy.dataExports = dataExportsProxy.dataExports.concat(response.data.data.userDataExports)
    } else {
      dataExportsProxy.dataExports = response.data.data.userDataExports
    }
    dataExportsProxy.pagination = response.data.data.pagination
  } catch (e) {
    if (e instanceof Error) {
      dataExportsProxy.apiCall.error = e.message
    }
  } finally {
    if (displayLoader) { dataExportsProxy.apiCall.loading = false }
  }
}
